<template>
  <div>
    <v-container>
      <v-tabs class="wz-report-tabs" v-model="selectedTab" background-color="white">
        <v-tab v-for="tab in tabs" :key="tab.name">
          {{ tab.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="selectedTab">
        <v-tab-item>
          <OverviewReport />
        </v-tab-item>
        <v-tab-item>
          <WeeklyReport />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>
<script>
import OverviewReport from '../components/OverviewReport.vue';
import WeeklyReport from '../components/WeeklyReport.vue';

export default {
  components: {
    OverviewReport,
    WeeklyReport
  },
  data: () => {
    return {
      selectedTab: 0,
      tabs: [{ name: "Overview" }, { name: "Weekly" }],
    };
  },
};
</script>
<style scoped>
.wz-report-tabs {
  position: fixed;
  top: 36px;
  margin: auto;
  z-index: 100;
}
</style>